import React from 'react';
import CustomDonutChart from "../components/graphs/CustomDonutChart";
import { formatGraphTypeNames } from "../utils";
import ContainerWrapper from "../components/microComponents/ContainerWrapper";
import GraphsWrapper from "../components/microComponents/wrapper/GraphsWrapper";
import { chartTypes } from "../utils/constants";
import InfoCard from '../components/graphs/InfoCard';
import { mockCustomLineGraphData } from '../utils/mock';
import CustomLineGraph from '../components/graphs/CustomLineGraph';
import InnerLoader from '../components/microComponents/InnerLoader';
import { useApp } from '../context/AppContext';
import OrganizationSelector from '../components/microComponents/OrganizationSelector';
import FarmSelector from '../components/microComponents/FarmSelector';

const ESGDetails = () => {
    const {
        loading,
        graphsData
    } = useApp();

    const mockCards = [
        { order: '4', graph_type: 'card', answer: 0 },
        // { order: '6', graph_type: 'card', answer: 0 },
        { order: '9', graph_type: 'card', answer: 0 },
        { order: "10", graph_type: 'card', answer: 0 },
    ]

    return (
        <ContainerWrapper>
            <div className="flex flex-col items-center w-full max-w-[1400px] mx-auto min-h-[calc(100vh-2rem)]">

                <div className="w-full flex justify-between items-center mb-6">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-2">
                            ESG Dashboard {loading && <InnerLoader
                                divSize={{ width: "30px", height: "30px" }}
                                loaderSize={{ width: "28px", height: "28px" }}
                            />}
                        </h1>
                        <p className="text-gray-600 mt-2">Environmental, Social, and Governance Metrics</p>
                    </div>
                    <div className="flex gap-4">
                        <FarmSelector />
                        <OrganizationSelector />
                    </div>
                </div>

                {/* Cards */}
                {/* <div className="w-full mb-6">
                    <div className="flex flex-row gap-3 overflow-x-auto pb-2">
                        {graphsData?.length > 0 ? graphsData?.map((card, index) => (
                            parseInt(card?.order) <= 10 && parseInt(card?.order) !== 6 && card?.graph_type === chartTypes['card'] &&
                            <InfoCard key={index} cardDetails={card} className="metric-card-animate" />
                        )) : mockCards?.map((card, index) => (
                            <InfoCard key={index} cardDetails={card} className="metric-card-animate" />
                        ))}
                    </div>
                </div> */}

                <div className="w-full space-y-6">
                    <div className="flex flex-wrap gap-6">

                        {/* Question order is 13 */}
                        <div className="flex-grow basis-[calc(75%-12px)] min-w-[300px]">
                            <GraphsWrapper
                                label={''}
                                questionNo={graphsData[11]?.order}
                                question={mockCustomLineGraphData}
                                showThisYear={true}
                                className="h-full metric-card-animate"
                            >
                                {<CustomLineGraph questionData={graphsData[11]} />}
                            </GraphsWrapper>
                        </div>

                        {/* Question order is 1 */}
                        <div className="flex-grow basis-[calc(25%-12px)] min-w-[200px]">
                            <GraphsWrapper
                                label={graphsData[0]?.graph_type ? formatGraphTypeNames(graphsData[0].graph_type) : ''}
                                questionNo={graphsData[0]?.order}
                                question={{ ...graphsData[0], question_text: 'Socio-Demographics' }}
                                className="h-full metric-card-animate"
                            >
                                {<CustomDonutChart questionData={graphsData[0]} />}
                            </GraphsWrapper>
                        </div>
                    </div>
                </div>
            </div>
        </ContainerWrapper>
    );
};

export default ESGDetails;